import axios from 'axios';
import { API_BASE_URL } from '../config/api';

export const testimonialService = {
  async getPublicTestimonials() {
    try {
      const response = await axios.get(`${API_BASE_URL}/testimonials`);
      return Array.isArray(response.data) ? response.data : [];
    } catch (err) {
      console.warn('Could not fetch public testimonials from API:', err);
      return [];
    }
  },
};
